
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ApproachHero from './components/ApproachHero';
import ProcessSection from './components/ProcessSection';
import DifferentiationSection from './components/DifferentiationSection';

const ApproachPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <ApproachHero />
      <ProcessSection />
      <DifferentiationSection />
      <Footer />
    </div>
  );
};

export default ApproachPage;
